import { useThemeProps } from '@mui/material/styles';
import React, { useId, useMemo } from 'react';
const boxShadow = (boxShadow)=>({ ownerState })=>({
            ...!ownerState.disableElevation && {
                boxShadow
            }
        });
const stripDiacritics = (label)=>label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const AutoIdButton = /*#__PURE__*/ React.forwardRef(function MyInput(inProps, ref) {
    const props = useThemeProps({
        props: inProps,
        name: 'MuiButtonBaseAutoId'
    });
    const { children, LinkComponent, type, disabled, ...other } = props;
    const reactId = useId();
    const computedId = useMemo(()=>{
        const label = React.Children.toArray(children).filter((child)=>typeof child === 'string').join('').replaceAll(' ', '-');
        if (label) {
            return `${stripDiacritics(label)}${reactId}`;
        }
        return undefined;
    }, [
        children,
        reactId
    ]);
    // copied from source code of ButtonBase
    let Component = 'button';
    if (other.href || other.to) {
        Component = LinkComponent;
    }
    const buttonProps = {};
    if (Component === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) {
            buttonProps.role = 'button';
        }
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    return /*#__PURE__*/ React.createElement(Component, {
        id: computedId,
        ...buttonProps,
        ...other,
        ref: ref
    }, children);
});
export default function Button(theme) {
    return {
        MuiButton: {
            defaultProps: {
                component: AutoIdButton
            },
            styleOverrides: {
                root: {
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    borderRadius: theme.radius(0.5),
                    textTransform: 'none'
                },
                sizeLarge: {
                    height: 48
                },
                // contained
                containedInherit: {
                    color: 'inherit',
                    '&:hover': {
                        backgroundColor: theme.palette.grey[400]
                    },
                    ...boxShadow(theme.customShadows.z8)
                },
                containedPrimary: boxShadow(theme.customShadows.primary),
                containedSecondary: boxShadow(theme.customShadows.secondary),
                containedInfo: boxShadow(theme.customShadows.info),
                containedSuccess: boxShadow(theme.customShadows.success),
                containedWarning: boxShadow(theme.customShadows.warning),
                containedError: boxShadow(theme.customShadows.error),
                // outlined
                outlinedInherit: {
                    border: `1px solid ${theme.palette.grey[500_32]}`,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                },
                textInherit: {
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                }
            }
        }
    };
}
